var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#animatedEmoji_svg__clip0_4483_330801)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.133 30v-2.864C7.84 26.684 2.858 21.42 2.858 15.013c0-6.702 5.453-12.155 12.155-12.155 6.407 0 11.671 4.982 12.123 11.275H30C29.544 6.252 23.01 0 15.013 0 6.722 0 0 6.722 0 15.013 0 23.01 6.252 29.544 14.133 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.374 14.168c-.431-5.339-4.913-9.55-10.361-9.55-5.732 0-10.396 4.663-10.396 10.395 0 5.448 4.212 9.93 9.55 10.361.447-5.975 5.232-10.76 11.207-11.206z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.289 15.893c-5.732 0-10.396 4.664-10.396 10.396v2.858l13.254-13.254h-2.858z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "animatedEmoji_svg__clip0_4483_330801"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
}
export default SvgAnimatedEmoji;